module.exports = __webpack_public_path__ + "assets/img/official.eb1cbf1a.jpg";